<template>
  <div id="detalhes">
    <form @submit.prevent="salvar">
      <b-form-group>
        <label for="input-inicio">Início</label><br />
        <input type="time" id="input-inicio" class="form-control" v-model="detalhes.inicio"
          :disabled="aprovado || competenciaBloqueada" ref="inicio" @blur="preencherDuracao()">
      </b-form-group>
      <b-form-group>
        <label for="input-termino">Término</label><br />
        <input type="time" id="input-termino" class="form-control" v-model="detalhes.termino"
          :disabled="aprovado || competenciaBloqueada" ref="termino" @blur="preencherDuracao()">
      </b-form-group>
      <b-form-group>
        <label for="input-duracao">Duração</label><br />
        <input type="time" id="input-duracao" class="form-control" v-model="detalhes.duracao" :disabled="true"
          ref="duracao">
      </b-form-group>

      <b-form-group style="margin-bottom: 0">
        <meta-select id="input-tipo-tarefa" label="Tipo de Tarefa" name="tipo-tarefa" v-model="detalhes.tipoTarefa"
          :disabled="aprovado || competenciaBloqueada" attr-id="id" attr-label="tipo_tarefa" :options="tiposTarefa"
          select-label="Selecionar" deselect-label="Remover" placeholder="Selecionar..." ref="tipoTarefa">
        </meta-select>
      </b-form-group>

      <b-form-group style="margin-bottom: 0">
        <meta-select id="input-cliente" label="Cliente" name="cliente" v-model="detalhes.cliente"
          :disabled="aprovado || competenciaBloqueada || !!detalhes.id || detalhes.isSugestao" attr-id="id"
          attr-label="name" :options="clientes" select-label="Selecionar" deselect-label="Remover"
          placeholder="Selecionar..." ref="cliente">
        </meta-select>
      </b-form-group>

      <!-- Projeto -->
      <b-form-group style="text-align: center" v-if="(detalhes.cliente || {}).id && carregandoProjetos">
        <div class="lds-ellipsis lds-ellipsis-sm">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p>Carregando Projetos</p>
      </b-form-group>

      <b-form-group style="margin-bottom: 0"
        v-else-if="(detalhes.cliente || {}).id && (!carregandoProjetos && !!projetos.length)">
        <meta-select id="input-projeto" label="Projeto" name="projeto" v-model="detalhes.projeto"
          :disabled="aprovado || competenciaBloqueada || !!detalhes.id || detalhes.isSugestao" attr-id="id"
          attr-label="name" :options="projetos" select-label="Selecionar" deselect-label="Remover"
          placeholder="Selecionar..." ref="projeto">
        </meta-select>
      </b-form-group>
      <!-- Fim Projeto -->

      <template v-if="podeAlterarDemanda">
        <!-- Demandas -->
        <b-form-group style="text-align: center" v-if="
          (detalhes.cliente || {}).id &&
          carregandoDemandas
        ">
          <div class="lds-ellipsis lds-ellipsis-sm">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p>Carregando Demandas</p>
        </b-form-group>

        <b-form-group v-else-if="
          (detalhes.cliente || {}).id &&
          ((detalhes.projeto || {}).id || (!carregandoProjetos && !projetos.length)) &&
          !demandas.length
        ">
          <label>Demanda</label><br />
          <p class="demanda">
            Nenhuma demanda encontrada para este projeto
          </p>
        </b-form-group>

        <b-form-group style="margin-bottom: 0" v-else-if="
          (detalhes.cliente || {}).id &&
          ((detalhes.projeto || {}).id || (!carregandoProjetos && !projetos.length))
        ">
          <meta-select id="input-demanda" label="Demanda" name="demanda" v-model="detalhes.demanda"
            :disabled="aprovado || competenciaBloqueada || detalhes.isSugestao" attr-id="id" attr-label="titulo"
            :options="demandas" select-label="Selecionar" deselect-label="Remover" placeholder="Selecionar..."
            ref="demanda">
          </meta-select>
        </b-form-group>
      </template>

      <b-form-group v-else-if="detalhes.issue">
        <label>Demanda</label><br />
        <p class="demanda">
          <a :href="detalhes.url" target="_blank" title="Abrir Gitlab">{{ detalhes.issue }}</a>
        </p>
      </b-form-group>
      <!-- Demandas -->

      <b-form-group>
        <label for="input-descricao">Descrição</label>
        <textarea id="input-descricao" class="form-control" v-model="detalhes.descricao"
          placeholder="Descrição breve das tarefas executadas..."
          :disabled="aprovado || competenciaBloqueada"></textarea>
      </b-form-group>

      <div class="">
        <button :disabled="!podeSalvar" class="btn btn-block btn-primary"
          v-if="!aprovado && !competenciaBloqueada">Salvar</button>
        <button v-on:click="deletar" type="button" class="btn btn-block btn-danger"
          v-if="detalhes.id && !aprovado && !competenciaBloqueada">Excluir</button>
        <button v-on:click="resetarDados" type="button" class="btn btn-block btn-default">Cancelar</button>

      </div>
    </form>
  </div>
</template>

<style lang="scss">
#detalhes {
  width: 100%;
  background-color: white;
  padding: 15px;
  margin-top: -16px;
  border-radius: 0 0 15px 0;
  margin-bottom: 15px;
  height: 100%;
  border: 1px solid #ccc;
  border-top: none;

  label[for="input-tipo-hora"]::after,
  label[for="input-inicio"]::after,
  label[for="input-termino"]::after,
  label[for="input-duracao"]::after,
  label[for="input-cliente"]::after,
  label[for="input-projeto"]::after,
  label[for="input-descricao"]::after,
  label[for="input-tipo-tarefa"]::after {
    text-align: right;
    content: " *";
    color: red;
    vertical-align: middle;
  }

  p.demanda {
    text-align: center;
    border-radius: 4px;
    border: 1px solid #ccd0d2;
    padding: 10px;
  }
}
</style>

<script>
import Uteis from '@/mixins/utils.js'
import MetaSelect from 'meta-select'
import _ from 'lodash';

export default {
  name: 'detalhes',

  props: {
    competenciaBloqueada: {
      type: Boolean,
      required: true,
    },
    apontamento: {
      type: Object,
      required: true,
    },
    dataSelecionada: {
      type: String,
      required: true,
    },
    callbackSuccess: {
      type: Function,
      required: true,
    }
  },

  components: {
    MetaSelect,
  },

  mixins: [
    Uteis,
  ],

  data() {
    return {
      /**
       * Atributos do cadastro
       */
      detalhes: {
        id: null,
        descricao: '',
        inicio: '',
        termino: '',
        duracao: '',
        status: '',
        log_duracao: '',
        tipoHora: null,
        tipoTarefa: null,
        cliente: null,
        projeto_id: null,
        projeto: null,
        demanda: null,
        demanda_id: null,
        isSugestao: false,
        url: null,
        issue: null,
      },

      /**
       * Atributos dos detalhes
       */
      clientes: [],
      projetos: [],
      demandas: [],
      tiposHora: [],
      tiposTarefa: [],

      carregandoDemandas: false,
      carregandoProjetos: false,
    };
  },

  computed: {
    aprovado() {
      return this.detalhes.status == this.status.aprovado;
    },

    podeSalvar() {
      try {
        return this.detalhes.inicio &&
          this.detalhes.termino &&
          this.detalhes.duracao &&
          this.detalhes.tipoTarefa &&
          this.detalhes.cliente.id &&
          this.detalhes.projeto.id &&
          (this.detalhes.id ? true : this.detalhes.duracao !== '00:00') &&
          this.detalhes.descricao;
      } catch (e) {
        return false;
      }
    },

    isEPS() {
      return this.$root.usuario('type_contract') === this.contrato.eps;
    },

    podeAlterarDemanda() {
      return !this.detalhes.isSugestao && (!this.detalhes.id || (this.detalhes.id && this.detalhes.demanda_id == null));
    },

    cliente() {
      return (this.detalhes.cliente || {}).cc_id || null;
    },

    projeto() {
      return (this.detalhes.projeto || {}).id || null;
    }
  },

  watch: {
    apontamento() {
      if (this.apontamento.cliente_id) {
        return this.editar(this.apontamento);
      }
    },

    cliente() {
      this.detalhes.demanda = null;
      this.detalhes.projeto = null;

      this.carregarProjetos();
    },

    projeto() {
      this.detalhes.demanda = null;

      this.carregarDemandas();
    },

    dataSelecionada() {
      this.resetarDados();
      this.resetarTypeHead();
    },
  },

  mounted() {
    this.carregarDados();
    this.$refs.inicio.focus();
    this.detalhes.tipoHora = { id: this.horas.normal };
  },

  methods: {
    /**
     * Carregar Informações em Tela
     */
    async carregarDados() {
      this.carregarClientes();
      this.carregarTiposTarefa();
      this.carregarTiposHora();
    },

    async carregarClientes() {
      try {
        const { data: response } = await this.$http.get('/cliente/usuario');

        this.clientes = response.clientes;
      } catch (e) {
        this.notificar('Ocorreu um erro ao carregar os Clientes.', 'apontamentos');
      }
    },

    async carregarTiposTarefa() {
      try {
        const { data: response } = await this.$http.get('/tipo-tarefa');

        this.tiposTarefa = response.tipos_tarefa;
      } catch (e) {
        this.notificar('Ocorreu um erro ao carregar os Tipos de Tarefas.', 'apontamentos');
      }
    },

    async carregarTiposHora() {
      try {
        const { data: response } = await this.$http.get('/tipo-hora');
        this.tiposHora = response.tipos_hora;
      } catch (e) {
        this.notificar('Ocorreu um erro ao carregar os Tipos de Horas.', 'apontamentos');
      }
    },

    async carregarDemandas() {
      if (!this.podeAlterarDemanda) {
        return false;
      }

      try {
        this.demandas = [];
        this.carregandoDemandas = true;

        console.log('CArregar demanda')

        if (this.detalhes.cliente && this.detalhes.projeto) {
          const demandas = await this.$http.get(`/demandas/cliente/${this.detalhes.cliente.id}/${this.detalhes.projeto.id}`);
          this.demandas = demandas.data;
        } else if (this.detalhes.cliente) {
          const demandas = await this.$http.get(`/demandas/cliente/${this.detalhes.cliente.id}`);
          this.demandas = demandas.data;
        }
      } catch (e) {
        this.notificar('Ocorreu um erro ao carregar as Demandas.', 'apontamentos');
      } finally {
        this.carregandoDemandas = false;
      }
    },

    async carregarProjetos() {
      if (!this.detalhes.cliente.id) {
        return false;
      }

      try {
        this.projetos = [];
        this.carregandoProjetos = true;

        const { data: response } = await this.$http.get(`/projeto-cliente/${this.detalhes.cliente.id}`);

        this.projetos = _.sortBy(response, o => o.name);

        // Caso não possua projeto, então busca demandas
        if (!this.projetos.length) {
          this.carregarDemandas();
        } else {
          this.selecionarProjeto();
        }
      } catch (e) {
        this.notificar('Ocorreu um erro ao carregar os Projetos.', 'apontamentos');
      } finally {
        this.carregandoProjetos = false;
      }
    },

    async selecionarProjeto() {
      if (this.detalhes.projeto_id) {
        const projeto = await _.filter(this.projetos, { id: this.detalhes.projeto_id })[0];

        this.$nextTick(() => {
          this.detalhes.projeto = projeto;
          this.detalhes.projeto_id = null;
        });

        return true;
      }

      return false;
    },

    /**
     * Salvar e editar
     */
    async salvar() {
      try {
        if (this.podeSalvar) {
          this.$events.$emit('loading', true);

          if (this.detalhes.duracao === '00:00') {
            return await this.deletar();
          }

          if (!await this.validar()) {
            return false;
          }
          const { data: response } = await this.$http.post('/apontamento-hora', this.getApontamentoDTO());

          if (!response.success && response.message) {
            return this.notificar(`Ocorreu um erro. ${response.message}.`, 'apontamentos');
          }

          this.resetarDados();
          this.callbackSuccess();
        }
      } catch (e) {
        console.log(e);
        this.notificar('Ocorreu um erro. Entre em contato com o administrador do sistema.', 'apontamentos');
        this.callbackSuccess();
      } finally {
        this.$events.$emit('loading', false);
      }
    },

    async validar() {
      try {
        if (!this.detalhes.cliente.cc_id) {
          this.notificar('O projeto em que você está tentando apontar horas ainda não está parametrizado. Entre em contato com seu gestor.', 'apontamentos')
          return false;
        }

        const valueIni = this.detalhes.inicio.split(':');
        const quantidadeIni = this.getSegundos(valueIni[0], valueIni[1]);
        const valueFim = this.detalhes.termino.split(':');
        const quantidadeFim = this.getSegundos(valueFim[0], valueFim[1]);
        if (quantidadeFim - quantidadeIni < 0) {
          this.notificar(`A data final não pode ser menor que a inicial.`, 'apontamentos');
          return false;
        }

        const values = this.detalhes.duracao.split(':');
        const quantidade = this.getSegundos(values[0], values[1]);
        const validacao = await this.validarApontamento(
          this.detalhes.id,
          this.detalhes.log_duracao,
          quantidade,
          this.detalhes.tipoHora.id,
          this.dataSelecionada,
          'apontamentos'
        );

        return validacao;
      } catch (e) {
        console.error(e);
        return false;
      }
    },

    async deletar() {
      try {
        const { data: response } = await this.$http.delete(`/apontamento-hora/${this.detalhes.id}`);

        if (response.success === false) {
          throw new Error();
        }

        this.notificar('Registro excluido com sucessso!', 'apontamentos', 'success');
      } catch (e) {
        console.error(e);
        this.notificar('Ocorreu um erro ao deletar o apontamento.', 'apontamentos');
      } finally {
        this.resetarDados();
        this.callbackSuccess();
      }
    },

    getApontamentoDTO() {
      const values = this.detalhes.duracao.split(':');
      const valueIni = this.detalhes.inicio.split(':');
      const valueFim = this.detalhes.termino.split(':');
      const demanda = this.detalhes.demanda ?
        this.detalhes.demanda.id : null;

      return {
        id: this.detalhes.id,
        data: this.dataSelecionada,
        inicio: this.getSegundos(valueIni[0], valueIni[1]),
        termino: this.getSegundos(valueFim[0], valueFim[1]),
        duracao: this.getSegundos(values[0], values[1]),
        descricao: this.detalhes.descricao || null,
        cliente_cc_id: this.cliente,
        project_id: this.projeto || null,
        demanda_id: demanda || this.detalhes.demanda_id,
        tipo_tarefa_id: this.detalhes.tipoTarefa ? (this.detalhes.tipoTarefa.id || null) : null,
        tipo_hora_id: this.detalhes.tipoHora ? (this.detalhes.tipoHora.id || null) : null,
      };
    },

    /**
     * Resetar
     */
    resetarDados() {
      this.detalhes = {
        id: null,
        descricao: '',
        inicio: '',
        termino: '',
        duracao: '',
        status: '',
        log_duracao: '',
        tipoHora: { id: this.horas.normal },
        tipoTarefa: null,
        cliente: null,
        projeto_id: null,
        projeto: null,
        demanda: null,
        demanda_id: null,
        isSugestao: false,
        url: null,
        issue: null,
      };

      this.resetarTypeHead();
    },

    resetarTypeHead() {
      this.$refs.tipoTarefa.selected = null;
      this.$refs.cliente.selected = null;

      if (this.$refs.demanda) {
        this.$refs.demanda.selected = null;
      }
    },

    async editar(item) {
      try {
        console.log('editar', item);
        this.detalhes.tipoHora = { id: this.horas.normal };

        this.preencherTipoTarefa(item);
        this.preencherDados(item);

        this.$refs.inicio.focus();

        if (item.cliente_id) {
          this.detalhes.cliente = _.filter(this.clientes, { id: item.cliente_id })[0];
        }
      } catch (e) {
        console.error(e);
      }
    },

    preencherTipoTarefa(item) {
      if (item.tipo_tarefa_id) {
        const tipoTarefa = _.filter(this.tiposTarefa, { id: item.tipo_tarefa_id });
        return this.detalhes.tipoTarefa = tipoTarefa.length ? tipoTarefa[0] : null;
      }

      this.detalhes.tipoTarefa = null;
      // this.$refs.tipoTarefa.selected = null;
    },

    preencherDuracao() {
      if (!this.detalhes.inicio || !this.detalhes.termino) {
        return;
      }

      // Não valida se algum dos campos ainda está em "00:00"
      if (this.detalhes.inicio === '00:00' || this.detalhes.termino === '00:00') {
        this.detalhes.duracao = '00:00';
        return;
      }

      const valueIni = this.detalhes.inicio.split(':');
      const quantidadeIni = this.getSegundos(valueIni[0], valueIni[1]);
      const valueFim = this.detalhes.termino.split(':');
      const quantidadeFim = this.getSegundos(valueFim[0], valueFim[1]);
      if (quantidadeFim - quantidadeIni < 0) {
        this.notificar(`A data final não pode ser menor que a inicial.`, 'apontamentos');
        return false;
      }
      this.detalhes.duracao = this.getDuracao(quantidadeFim - quantidadeIni);
      // this.$refs.tipoTarefa.selected = null;
    },

    preencherDados(item) {
      Object.assign(this.detalhes, {
        id: item.id,
        descricao: item.descricao || '',
        inicio: this.getDuracao(item.inicio),
        termino: this.getDuracao(item.termino),
        duracao: this.getDuracao(item.duracao),
        status: item.status_id,
        log_duracao: item.duracao,
        isSugestao: !!item.sugestao,
        projeto_id: item.project_id || null,
        demanda_id: item.demanda_id || (item.issue_id || null),
        url: this.getUrlGitlab(item),
        issue: item.issue ? `${item.projeto}${item.issue ? `#${item.issue}` : ''}` : null,
      });
    },

    getUrlGitlab(apontamento) {
      const url = `http://gitlab.meta.com.br/${apontamento.path}/`;
      const projeto = apontamento.project_path ? `${apontamento.project_path}/` : '';
      const issue = apontamento.issue ? `issues/${apontamento.issue}` : '';

      return `${url}${projeto}${issue}`;
    },

    async duplicar() {
      const item = { ...this.apontamento };
      console.log('duplicar', item);
      try {
        this.detalhes.id = null;
        this.detalhes.descricao = '';
        this.detalhes.inicio = '';
        this.detalhes.termino = '';
        this.detalhes.duracao = '';
        this.detalhes.log_duracao = '';
        this.detalhes.status = '';
        this.detalhes.isSugestao = false;

        this.detalhes.tipoHora = { id: this.horas.normal };
        this.preencherTipoTarefa(item);

        this.detalhes.cliente = this.clientes.find(c => c.id === item.cliente_id) || null;
        this.detalhes.projeto = this.projetos.find(p => p.id === item.project_id) || null;
        this.detalhes.projeto_id = item.project_id || null;

        if (this.detalhes.cliente && this.detalhes.cliente.id) {
          await this.carregarProjetos();
          await this.$nextTick();
          if (this.detalhes.projeto && this.detalhes.projeto.id) {
            await this.carregarDemandas();
            await this.$nextTick();
          }
        }

        const demandaObj = this.demandas.find(d => String(d.id) === String(item.demanda_id));
        this.detalhes.demanda = demandaObj || null;

        this.detalhes.url = this.getUrlGitlab(item);
        this.detalhes.issue = item.issue ? `${item.projeto}${item.issue ? `#${item.issue}` : ''}` : null;

        await this.$nextTick();

        if (this.$refs.inicio) this.$refs.inicio.focus();
      } catch (e) {
        console.error(e);
      }
    },
  }
}
</script>
